import { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { connect } from 'react-redux';

import Icon from 'components/atoms/Icon';
import Image from 'components/atoms/Image';
import ToggleButton from 'components/atoms/ToggleButton';
import { bindActionCreators, Dispatch } from 'redux';
import {
    SetLayerControlsAction,
    setLayerControlsAction,
    SetLayoutAction,
    setLayoutAction,
    setSwitchAction,
} from 'store/actions/layoutActions';
import { setPilotagePlansAction } from 'store/actions/portActions';
import { OpenModal, PlanType, PortType, RootState, SwitchType, UserType } from 'types';
import { MainControlsInterface, TogglePlanInterface } from 'types/functions';
import { checkDifferent, clone, getId } from 'utils/formHandlers';
import { translate } from 'utils/translate';
import { twclsx } from 'utils/twclsx';

interface PlansMenuComponentProps {
    switchs: SwitchType;

    active: boolean;
    mode: string;
    port: PortType;
    mainControls: MainControlsInterface;
    pilotagePlans: PlanType[];
    setPilotagePlansAction: (plansmenu: PlanType[]) => void;
    setLayerControlsAction: SetLayerControlsAction;
    setLayoutAction: SetLayoutAction;
    setSwitchAction: (key: string, value: object) => void;
    openModelFunction: OpenModal;
    user: UserType;
}

interface PlansMenuComponentState {
    active: boolean;
    switchs: SwitchType;

    mode: string;
    port: PortType | null;
    pilotagePlans: PlanType[];
}

class PlansMenu extends Component<PlansMenuComponentProps, PlansMenuComponentState> {
    constructor(props: PlansMenuComponentProps) {
        super(props);
        this.state = {
            mode: 'search',

            switchs: clone(props.switchs),
            port: props.port,
            active: props.active,
            pilotagePlans: props.pilotagePlans,
        };
    }

    static getDerivedStateFromProps(props: PlansMenuComponentProps, state: PlansMenuComponentState) {
        if (
            checkDifferent(props.port, state.port) ||
            props.active !== state.active ||
            props.mode !== state.mode ||
            checkDifferent(
                Object.fromEntries(
                    Object.entries(props.switchs).filter(([key, value]) => {
                        return value.mode === props.mode || value.mode === 'all';
                    })
                ),
                Object.fromEntries(
                    Object.entries(state.switchs).filter(([key, value]) => {
                        return value.mode === props.mode || value.mode === 'all';
                    })
                )
            ) ||
            checkDifferent(props.pilotagePlans, state.pilotagePlans)
        ) {
            return {
                active: props.active,
                mode: props.mode,
                switchs: Object.fromEntries(
                    Object.entries(props.switchs).filter(([key, value]) => {
                        return value.mode === props.mode || value.mode === 'all';
                    })
                ),
                pilotagePlans: props.pilotagePlans,
            };
        }
        return null;
    }

    componentDidMount(): void {
        this.props.setLayerControlsAction({
            togglePlan: this.togglePlan,
        });
    }

    togglePlan: TogglePlanInterface = (key: string | undefined, keyPress?: any): void => {
        this.props.setPilotagePlansAction(
            this.state.pilotagePlans.map((plan) => (plan.key === key ? { ...plan, loading: true } : plan))
        );

        setTimeout(() => {
            this.props.setPilotagePlansAction(
                this.state.pilotagePlans.map((plan) => {
                    if (plan.key === key) {
                        return {
                            ...plan,
                            value: !plan.value,
                            loading: false,
                        };
                    }

                    // 👇 Shift pressed → keep other plans unchanged
                    if (keyPress?.shift === true) {
                        return plan;
                    }

                    // 👇 No shift → reset other plans
                    return {
                        ...plan,
                        value: false,
                    };
                })
            );
        }, 500);
    };

    showPilotagePlansetting = () => {
        this.props.openModelFunction(
            'pilotagePlansSettingsModel',
            0,
            'small',
            {},
            {
                onCancel: () => {
                    this.props.openModelFunction('pilotagePlansSettingsModel');
                },
            },
            true
        );
    };

    createPlanSetting = (plan: PlanType) => {
        return [
            {
                key: getId(),
                name: 'Routes',
                disabled: plan?.route ? plan?.route === '' : true,
                type: 'route',
                options: [plan?.route || ''],
            },
            {
                key: getId(),
                name: 'Reference points',
                value: true,
                type: 'wayPoint',
                disabled: plan?.markerPoints ? plan?.markerPoints?.length === 0 : true,
                options: plan?.markerPoints || [],
            },
            {
                key: getId(),
                name: 'XTDs',
                disabled: plan?.XTD ? plan?.XTD === '' : true,
                type: 'xtd',
                options: [plan?.XTD || ''],
            },
            {
                key: getId(),
                name: 'Safety margins',
                disabled: plan?.safetyMargins ? plan?.safetyMargins?.length === 0 : true,
                type: 'reservedAreas',
                options: plan?.safetyMargins || [],
            },
            {
                key: getId(),
                name: 'NoGoArea',
                disabled: plan?.noGoAreas ? plan?.noGoAreas?.length === 0 : true,
                type: 'reservedAreas',
                options: plan?.noGoAreas || [],
            },
            {
                key: getId(),
                name: 'manoeuvreAreas',
                disabled: plan?.manoeuvreAreas ? plan?.manoeuvreAreas?.length === 0 : true,
                type: 'manoeuvre',
                options: plan?.manoeuvreAreas || [],
            },
        ];
    };

    showPilotagePlanFeatures = (plan: PlanType) => {
        console.log(plan);
        this.props.openModelFunction(
            'planFeatureModel',
            0,
            'medium',
            {
                pilotagePlanSetting: this.createPlanSetting(plan),
                plan,
            },
            {
                onCancel: () => {
                    this.props.openModelFunction('planFeatureModel');
                },
                onConfirm: () => {
                    // console.log('saved');
                },
            },
            true
        );
    };

    render() {
        return (
            <div
                className={twclsx(
                    this.state.active ? 'left-0 ' : 'left-out',
                    'mt-14',
                    'h-page',
                    'border-r',
                    'border-gray-300',
                    'position-transition',
                    'fixed',
                    'z-20',
                    'w-menu',
                    'ml-14',
                    'h-page',
                    'top-0',
                    'bg-white'
                )}
            >
                <div className="flex justify-between border-b border-gray-300 py-3  px-2">
                    <div className="text-lg font-bold">{translate('Pilotage plans')}</div>
                    {/*hash close menu 'x'*/}
                    {/* <div
                        onClick={() => {
                            this.props.setLayoutAction([
                                {
                                    action: 'UPDATE_MENU',
                                    data: {
                                        name: 'plansmenuMenu',
                                        section: 'chart',
                                        state: false,
                                    },
                                },
                                {
                                    action: 'UPDATE_MENU',
                                    data: {
                                        name: 'plansmenuMenu',
                                        section: 'time',
                                        state: false,
                                    },
                                },
                                {
                                    action: 'UPDATE_MENU',
                                    data: {
                                        name: 'plansmenuMenu',
                                        section: 'playback',
                                        state: false,
                                    },
                                },
                            ]);
                        }}
                        className="cursor-pointer"
                    >
                        <Icon>
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M18 6l-12 12" />
                            <path d="M6 6l12 12" />
                        </Icon>
                    </div> */}
                </div>
                <Scrollbars autoHide className="w-full h-menu">
                    <div>
                        {this.state.pilotagePlans.length === 0 && (
                            <div className="font-bold no-select">{translate('Routes and XTDs')}</div>
                        )}
                        {this.state.pilotagePlans.length === 0 && (
                            <div className="font-bold no-select">{translate('Safety margins')}</div>
                        )}
                        {this.state.pilotagePlans.length >= 1 && (
                            <div className="px-2 mt-2">
                                <div className="flex items-start justify-between mb-2">
                                    <div className="font-bold no-select">{translate('Pilotage plans')}</div>
                                    <div onClick={this.showPilotagePlansetting} className="cursor-pointer">
                                        <Icon className="h-4 w-4 mt-0.5">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                            <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z" />
                                            <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                                        </Icon>
                                    </div>
                                </div>
                                {this.state.pilotagePlans.map((plan) => {
                                    return (
                                        <div key={plan.key} className="flex items-center gap-1 py-1">
                                            {plan.loading ? (
                                                <Image
                                                    alt="loading"
                                                    className="w-4 mx-1"
                                                    src="/static/images/loading.svg"
                                                ></Image>
                                            ) : (
                                                <ToggleButton
                                                    onChange={(name, value, keyPress) => {
                                                        console.log(name, value, keyPress);
                                                        this.togglePlan(plan.key, keyPress);
                                                    }}
                                                    value={plan.value || false}
                                                />
                                            )}
                                            <div className="flex justify-between items-start w-full">
                                                <div>{plan.name}</div>
                                                {plan.value && (
                                                    <div
                                                        className="cursor-pointer"
                                                        onClick={() => {
                                                            this.showPilotagePlanFeatures(plan);
                                                        }}
                                                    >
                                                        <Icon className="w-4 h-4">
                                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                            <path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                                                            <path d="M12 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                                                            <path d="M12 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                                                        </Icon>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </Scrollbars>
            </div>
        );
    }
}

const plansmenuStateToProps = (state: RootState) => ({
    switchs: state.layout.switchs,
    port: state.port.port,
    mode: state.layout.mode,
    pilotagePlans: state.port.pilotagePlans,
    openModelFunction: state.layout.openModelFunction,

    mainControls: state.layout.mainControls,
    user: state.user.user,
});
const plansmenuDispatchToProps = (dispatch: Dispatch) => ({
    setSwitchAction: bindActionCreators(setSwitchAction, dispatch),
    setPilotagePlansAction: bindActionCreators(setPilotagePlansAction, dispatch),
    setLayerControlsAction: bindActionCreators(setLayerControlsAction, dispatch),
    setLayoutAction: bindActionCreators(setLayoutAction, dispatch),
});

export default connect(plansmenuStateToProps, plansmenuDispatchToProps)(PlansMenu);
